import { useTranslation } from 'react-i18next';

import { Icon } from '~/components';
import { Modal } from '~/components/Modal';
import { cn } from '~/lib/cn';

import databricksImage from './images/databricks.svg?url';
import warnerImage from './images/wmg.svg?url';

interface SignInReminderModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

function SignInReminderModal({
  isOpen,
  onClose,
  url,
}: SignInReminderModalProps) {
  const { t } = useTranslation('marketing');

  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <div className="flex w-[500px] flex-col gap-sm rounded-sm border pt-lg bg-level-02 border-emphasis-subtle text-white">
        <div className="px-lg">
          <div className="flex justify-end pt-sm">
            <Icon
              type="xmark"
              aria-label="close"
              onClick={onClose}
              size="xl"
              className="hover:cursor-pointer"
            />
          </div>
          <div className="flex items-center gap-sm py-md align-middle">
            <img src={warnerImage} className="size-2xl rounded-xs" />
            <span className="text-body-lg text-tertiary-default">—</span>
            <img src={databricksImage} className="size-2xl rounded-xs" />
          </div>
          <div className="flex items-center justify-between py-sm align-middle">
            <div className="flex items-center align-middle">
              <span className="text-headline-md font-semibold">
                {t('signInReminderModal.title')}
              </span>
            </div>
          </div>
          <div className="pb-lg pr-xl text-body-sm">
            {t('signInReminderModal.message')}
          </div>
        </div>

        <div className="flex justify-end space-x-lg rounded-b-sm border-t-px p-md bg-level-03 border-emphasis-subtle">
          <a
            href={url}
            className={cn(
              'rounded-full px-md py-sm font-medium duration-300',
              'bg-primary-default hover:bg-primary-hover focus:bg-primary-pressed',
              'active:bg-primary-pressed disabled:bg-primary-disabled disabled:text-disabled',
            )}
          >
            {t('signInReminderModal.button')}
          </a>
        </div>
      </div>
    </Modal>
  );
}

SignInReminderModal.displayName = 'SignInReminderModal';

export { SignInReminderModal };
